var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoMute = function SvgVideoMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video_mute_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".video_mute_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "video_mute_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "video_mute_svg__st1",
    d: "M20.04 22.02c-.26 0-.51-.1-.71-.29L1.29 3.69A.996.996 0 1 1 2.7 2.28l18.04 18.04a.996.996 0 0 1-.7 1.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "video_mute_svg__st1",
    d: "M4.98 5.58H1.02C.46 5.58.01 6 0 6.52v11.23c0 .53.46.97 1.03.97H18c.27 0 .52-.1.7-.27L4.98 5.58zM23.23 6.7l-4.21 1.43V6.54c0-.53-.46-.97-1.03-.97H7.81L19.1 16.16l4.13 1.41c.37.12.77-.1.77-.44V7.15c0-.33-.4-.57-.77-.45z"
  })));
};
export default SvgVideoMute;